import React from "react";
import SingleWorkspace from "../Components/Workspace/SingleWorkspaceView";

const ViewSingleWorkspacesPage = () => {
  return <SingleWorkspace />;
};

export default ViewSingleWorkspacesPage;
